// src/lib/opportunity/formatDocumentSlotResolver.ts

import { listFormatDocumentSlots } from "./formatDocumentSlotClient.js";
import {
  selectFormatDocumentSlots,
  type FormatDocumentSlotDef,
} from "./formatDocumentSlotTypes.js";
import type { OpportunityFormatKey } from "../../types/opportunity.js";

export async function resolveFormatDocumentSlots(args: {
  formatKey: OpportunityFormatKey;
  productType: string;
}): Promise<FormatDocumentSlotDef[]> {
  const r = await listFormatDocumentSlots({
    format_key: args.formatKey,
    product_type: args.productType,
  });
  if (!r.ok) {
    return selectFormatDocumentSlots({
      slots: [],
      productType: args.productType,
      formatKey: args.formatKey,
    });
  }
  return selectFormatDocumentSlots({
    slots: r.data.slots,
    productType: args.productType,
    formatKey: args.formatKey,
  });
}
